import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const samples = [{
  src: 'https://cdn.magicpatterns.com/uploads/8S8mYVNNg1ErhWd5um7sDs/JUNIO_(6).png',
  alt: 'Ejemplo de actividad: Ni Una Menos - Producción escrita'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/kCCofC32HqH3LDa4HCvtrD/JUNIO_(14).png',
  alt: 'Ejemplo de actividad: Derechos argentinos sobre Malvinas'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/98dLNFG1joSH8PQMLH7gdZ/JUNIO_(23).png',
  alt: 'Ejemplo de actividad: Día de la Bandera'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1bNFmXKNQB31DC1yfmMRsA/efemerides_julio_(3).png',
  alt: 'Ejemplo de actividad: Semana de la Independencia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/eQ8mNm3qKnnkquNbPHpgY7/efemerides_julio_(8).png',
  alt: 'Ejemplo de actividad: Ciudadanía e Independencia'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cJTKF3GB1CB5hiSv9UUknR/efemerides_julio_(16).png',
  alt: 'Ejemplo de actividad: AMIA - Comprensión lectora'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qMBWBwTxnxbuf7be8CJVqZ/efemerides_agosto_(22).png',
  alt: 'Ejemplo de actividad: ESI - Convivencia y vínculos saludables'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/cHDanhz1rj8sa3xnLA8FS8/efemerides_agosto_(32).png',
  alt: 'Ejemplo de actividad: Semana Mundial de la Lactancia Materna'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3MrKdfTaa18FR87Aqc6pKz/septiembre_(3).png',
  alt: 'Ejemplo de actividad: Día de la Industria Nacional'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/uSSbye86mYpR5MJ5fES6ER/septiembre_(10).png',
  alt: 'Ejemplo de actividad: Semana de la Educación - Producción escrita'
}];
export function SampleCarousel() {
  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const paginate = useCallback((newDirection: number) => {
    setDirection(newDirection);
    setIndex(prev => (prev + newDirection + samples.length) % samples.length);
  }, []);
  const goTo = (i: number) => {
    setDirection(i > index ? 1 : -1);
    setIndex(i);
  };
  useEffect(() => {
    const timer = setInterval(() => paginate(1), 4500);
    return () => clearInterval(timer);
  }, [paginate]);
  return <div className="mb-6 max-w-md mx-auto" data-id="element-325">
      <p className="text-sm font-bold text-[#5B3FA0] uppercase tracking-wide mb-3" data-id="element-326">
        Así se ven las actividades por dentro
      </p>

      <div className="relative" data-id="element-327">
        <div className="relative overflow-hidden rounded-2xl border border-gray-200 shadow-lg bg-gray-50 aspect-[3/4]" data-id="element-328">
          <AnimatePresence initial={false} custom={direction} mode="popLayout" data-id="element-329">
            <motion.img key={index} src={samples[index].src} alt={samples[index].alt} custom={direction} initial={{
            opacity: 0,
            x: direction > 0 ? 60 : -60
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: direction > 0 ? -60 : 60
          }} transition={{
            duration: 0.4,
            ease: 'easeInOut'
          }} className="absolute inset-0 w-full h-full object-contain" data-id="element-330" />
          </AnimatePresence>
        </div>

        <button type="button" onClick={() => paginate(-1)} aria-label="Actividad anterior" className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[#5B3FA0] rounded-full p-2 shadow-md transition-colors" data-id="element-331">
          <ChevronLeftIcon className="w-5 h-5" data-id="element-332" />
        </button>
        <button type="button" onClick={() => paginate(1)} aria-label="Actividad siguiente" className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-[#5B3FA0] rounded-full p-2 shadow-md transition-colors" data-id="element-333">
          <ChevronRightIcon className="w-5 h-5" data-id="element-334" />
        </button>
      </div>

      <div className="flex justify-center gap-2 mt-3" data-id="element-335">
        {samples.map((_, i) => <button key={i} type="button" onClick={() => goTo(i)} aria-label={`Ir a la actividad ${i + 1}`} className={`h-2.5 rounded-full transition-all ${i === index ? 'w-6 bg-[#5B3FA0]' : 'w-2.5 bg-gray-300 hover:bg-gray-400'}`} data-id="element-336" />)}
      </div>
    </div>;
}